// extracted by mini-css-extract-plugin
module.exports = {"mobile":"(max-width: 1024px)","desktop":"(min-width: 1025px)"};